import {PlateElement} from "platejs/react";
import styles from "../styles/SlateEditor.module.scss";

export function Paragraph(props: any) {

    return <PlateElement {...props}
    >
        {props.children}
    </PlateElement>
}
